<template>
  <OmtStickedModal
    v-if="isOpen"
    @close="$emit('close')"
  >
    <CBox>
      <OmtRow mb="32px">
        <OmtTypography as="h1-bold"> Responder pendências </OmtTypography>
      </OmtRow>

      <CBox
        bg="#F6F6F9"
        border-radius="8px"
        p="20px"
        w="100%"
        mb="32px"
      >
        <CFlex align="flex-start">
          <CBox
            w="24px"
            h="24px"
            border-radius="50%"
            border="2px solid var(--colors-light-primary-dark-blue)"
            display="flex"
            align-items="center"
            justify-content="center"
            mr="14px"
            mt="2px"
            flex-shrink="0"
          >
            <img
              :src="require('../../../../public/images/Group3305.png')"
              alt=""
              style="width: 16px; height: 16px; object-fit: contain"
            />
          </CBox>

          <CBox flex-grow="1">
            <OmtTypography
              as="h3-bold"
              font-size="md"
              color="var(--colors-light-primary-dark-blue)"
              mb="12px"
            >
              Para continuidade da análise, solicitamos:
            </OmtTypography>

            <CBox
              v-if="reasons && reasons.length"
              ml="-20px"
            >
              <CBox pl="4">
                <ol class="pendency-list">
                  <li
                    v-for="(r, index) in reasons"
                    :key="`r-${index}`"
                  >
                    <OmtTypography as="p1">{{ r }}</OmtTypography>
                  </li>
                </ol>
              </CBox>
            </CBox>
          </CBox>
        </CFlex>
      </CBox>

      <OmtRow>
        <OmtTypography
          as="p1"
          fontWeight="600"
          size="14px"
          mb="16px"
        >
          Insira as imagens e/ou as informações solicitadas:
        </OmtTypography>
      </OmtRow>

      <OmtRow mb="32px">
        <ImageUploader
          :length="limitFiles"
          :initialValue="pictures"
          @change="onImageUploaderChange"
        />
      </OmtRow>

      <OmtRow>
        <div style="display: flex; align-items: center; margin-bottom: 8px">
          <CBox
            w="24px"
            h="24px"
            border-radius="50%"
            bg="#1CA0FF"
            display="flex"
            align-items="center"
            justify-content="center"
            mr="14px"
          >
            <OmtIcons
              name="user"
              size="1x"
              color="white"
            />
          </CBox>
          <OmtTypography
            as="p3"
            font-weight="bold"
            >Informações:</OmtTypography
          >
        </div>
      </OmtRow>

      <OmtRow>
        <CFlex
          flexDirection="column"
          alignItems="flex-end"
          mb="32px"
          w="100%"
        >
          <OmtTextarea
            class="input-observation"
            height="109px"
            padding="12px"
            placeholder="Inclua informações ou detalhes que podem complementar os documentos enviados."
            :initialValue="observation"
            :maxlength="350"
            w="100%"
            @change="handleChange"
          />
          <OmtTypography
            as="p2"
            color="var(--colors-light-primary-gray2)"
            mt="4px"
          >
            {{ observation.length }}/350
          </OmtTypography>
        </CFlex>
      </OmtRow>
    </CBox>

    <OmtButton
      w="100%"
      :disabled="disableButton"
      @click="submit"
    >
      Enviar
    </OmtButton>
  </OmtStickedModal>
</template>

<script>
import ImageUploader from "@/components/Molecules/ImageUploader";

export default {
  name: "PendingResponseModal",
  components: { ImageUploader },
  props: {
    reasons: {
      type: Array,
      default: () => []
    },
    pendencyObservation: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      limitFiles: 20,
      observation: this.pendencyObservation || "", // Inicializa com o prop
      pictures: []
    };
  },
  computed: {
    disableButton() {
      const hasObservation = this.observation && this.observation.trim().length > 0;
      const hasPictures = this.pictures && this.pictures.length > 0;

      return !hasObservation && !hasPictures;
    }
  },
  watch: {
    pendencyObservation(newVal) {
      this.observation = newVal || "";
    }
  },
  methods: {
    handleChange(text) {
      this.observation = text;
    },
    onImageUploaderChange(pictures) {
      const result = pictures?.filter(pic => pic.source && pic.name);
      this.pictures = result;
    },
    submit() {
      if (this.disableButton) return;
      this.$emit("submit", { pictures: this.pictures, obs: this.observation });
    }
  }
};
</script>

<style scoped>
.pendency-list {
  list-style: decimal inside;
  padding-left: 0;
  margin-top: 0;
}
.pendency-list li {
  margin-bottom: 4px;
}
.pendency-list li::marker {
  font-weight: bold;
}

::v-deep .input-observation {
  border: 0.5px solid #dadada;
  color: #8c8c8c !important;
}

::v-deep .input-observation::placeholder {
  color: #8c8c8c !important;
}
</style>
